import { useDeepCompareEffect } from 'react-use';

import { useSetRecoilState } from 'recoil';

import { registeredBreadcrumbsState } from './atoms';
import { BillBarBreadcrumb } from './types';

/**
 * `useRegisterBreadcrumbs` may be called within entity-specific pages (e.g. Model page)
 * to provide breadcrumbs that should be displayed in the BillBar.
 *
 * Note: This module should be imported directly (rather than though the index.ts file)
 * to ensure lazy loading of BillBar.
 */
function useRegisterBreadcrumbs(breadcrumbs: BillBarBreadcrumb[]) {
  const setRegisteredBreadcrumbs = useSetRecoilState(registeredBreadcrumbsState);
  useDeepCompareEffect(() => {
    setRegisteredBreadcrumbs((prev) => [...prev, ...breadcrumbs]);

    return () => {
      setRegisteredBreadcrumbs((prev) =>
        prev.filter((breadcrumb) => !breadcrumbs.includes(breadcrumb)),
      );
    };
  }, [breadcrumbs]);
}

export default useRegisterBreadcrumbs;
